export const API_URL = process.env.REACT_APP_MAINURL
export const MAIN_URL = process.env.REACT_APP_URL